import { RiEditBoxLine } from "react-icons/ri"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { Link } from "react-router-dom"
import { formattedDate } from "../../utils/dateFormatter"

export default function MyProfile() {
  const { user } = useSelector((state) => state.profile)
  const navigate = useNavigate()

  return (
    <>
    <div style={{ fontFamily: 'Arial, sans-serif' }}>
      <h1 className="mb-14 ml-16 md:ml-10 text-3xl font-medium text-blue-600">
        My Profile
      </h1>
      <div className="flex md:flex-row flex-col items-center justify-between rounded-md border-[1px] border-richblack-50 bg-richblack-5 p-8 px-12">
        <div className="flex md:flex-row flex-col items-center gap-x-4">
          <img
            src={user?.image}
            alt={`profile-${user?.firstName}`}
            className="aspect-square  mx-auto md:m-0 w-[78px] rounded-full object-cover"
          />
          <div className="space-y-1 mt-3 md:mt-0 text-center md:text-left">
            <p className="text-lg font-semibold text-richblack-800">
              {user?.firstName + " " + user?.lastName}
            </p>
            <p className="text-sm text-richblack-500">{user?.email}</p>
          </div>
        </div>
        
        <Link to="/dashboard/settings"
        className="bg-blue-600 text-white mt-5 md:mt-0 px-3 py-1 flex items-center gap-1 rounded-md font-medium">
        <button>Edit</button>
          <RiEditBoxLine />
        </Link>
        
      </div>
      <div className="my-10 flex flex-col gap-y-10 rounded-md border-[1px] border-richblack-50 bg-richblack-5 p-8 px-12">
        <div className="flex w-full items-center justify-between">
          <p className="text-lg font-semibold text-richblack-800">About</p>
          <Link to="/dashboard/settings"
        className="bg-blue-600 text-white px-3 py-1 flex items-center gap-1 rounded-md font-medium">
        <button>Edit</button>
          <RiEditBoxLine />
        </Link>
        </div>
        <p
          className={`${
            user?.additionalDetails?.about
              ? "text-richblack-800"
              : "text-richblack-400"
          } text-sm font-medium`}
        >
          {user?.additionalDetails?.about ?? "Write Something About Yourself"}
        </p>
      </div>
      <div className="my-10 flex flex-col gap-y-10 rounded-md border-[1px] border-richblack-50 bg-richblack-5 p-8 px-12">
        <div className="flex w-full items-center justify-between">
          <p className="text-lg font-semibold text-richblack-800">
            Personal Details
          </p>
          <Link to="/dashboard/settings"
        className="bg-blue-600 text-white px-3 py-1 flex items-center gap-1 rounded-md font-medium">
        <button>Edit</button>
          <RiEditBoxLine />
        </Link>
        </div>
        <div className="flex md:flex-row flex-col gap-y-5 md:gap-y-0 max-w-[500px] justify-between">
          <div className="flex flex-col gap-y-5">
            <div>
              <p className="mb-2 text-sm text-richblack-600">First Name</p>
              <p className="text-sm font-medium text-richblack-800">
                {user?.firstName}
              </p>
            </div>
            <div>
              <p className="mb-2 text-sm text-richblack-600">Email</p>
              <p className="text-sm font-medium text-richblack-800">
                {user?.email}
              </p>
            </div>
            <div>
              <p className="mb-2 text-sm text-richblack-600">Gender</p>
              <p className="text-sm font-medium text-richblack-800">
                {user?.additionalDetails?.gender ?? "Add Gender"}
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-y-5">
            <div>
              <p className="mb-2 text-sm text-richblack-600">Last Name</p>
              <p className="text-sm font-medium text-richblack-800">
                {user?.lastName}
              </p>
            </div>
            <div>
              <p className="mb-2 text-sm text-richblack-600">Phone Number</p>
              <p className="text-sm font-medium text-richblack-800">
                {user?.additionalDetails?.contactNumber ?? "Add Contact Number"}
              </p>
            </div>
            <div>
              <p className="mb-2 text-sm text-richblack-600">Date Of Birth</p>
              <p className="text-sm font-medium text-richblack-800">
                {formattedDate(user?.additionalDetails?.dateOfBirth) ??
                  "Add Date Of Birth"}
              </p>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  )
}




// import { RiEditBoxLine } from "react-icons/ri"
// import { useSelector } from "react-redux"
// import { useNavigate } from "react-router-dom"
// import { Link } from "react-router-dom"
// import { formattedDate } from "../../../utils/dateFormatter"

// export default function MyProfile() {
//   const { user } = useSelector((state) => state.profile)
//   const navigate = useNavigate()

//   return (
//     <>
//       <h1 className="mb-14 ml-16 md:ml-10 text-3xl font-medium text-richblack-800">
//         My Profile
//       </h1>
//       <div className="flex md:flex-row flex-col items-center justify-between rounded-md border-[1px] border-richblack-50 bg-richblack-5 p-8 px-12">
//         <div className="flex md:flex-row flex-col items-center gap-x-4">
//           <img
//             src={user?.image}
//             alt={`profile-${user?.firstName}`}
//             className="aspect-square  mx-auto md:m-0 w-[78px] rounded-full object-cover"
//           />
//           <div className="space-y-1 mt-3 md:mt-0 text-center md:text-left">
//             <p className="text-lg font-semibold text-richblack-800">
//               {user?.firstName + " " + user?.lastName}
//             </p>
//             <p className="text-sm text-richblack-500">{user?.email}</p>
//           </div>
//         </div>
        
//         <Link to="/dashboard/settings"
//         className="bg-yellow-50 mt-5 md:mt-0 px-3 py-1 flex items-center gap-1 rounded-md font-medium">
//         <button>Edit</button>
//           <RiEditBoxLine />
//         </Link>
        
//       </div>
//       <div className="my-10 flex flex-col gap-y-10 rounded-md border-[1px] border-richblack-50 bg-richblack-5 p-8 px-12">
//         <div className="flex w-full items-center justify-between">
//           <p className="text-lg font-semibold text-richblack-800">About</p>
//           <Link to="/dashboard/settings"
//         className="bg-yellow-50 px-3 py-1 flex items-center gap-1 rounded-md font-medium">
//         <button>Edit</button>
//           <RiEditBoxLine />
//         </Link>
//         </div>
//         <p
//           className={`${
//             user?.additionalDetails?.about
//               ? "text-richblack-800"
//               : "text-richblack-400"
//           } text-sm font-medium`}
//         >
//           {user?.additionalDetails?.about ?? "Write Something About Yourself"}
//         </p>
//       </div>
//       <div className="my-10 flex flex-col gap-y-10 rounded-md border-[1px] border-richblack-50 bg-richblack-5 p-8 px-12">
//         <div className="flex w-full items-center justify-between">
//           <p className="text-lg font-semibold text-richblack-800">
//             Personal Details
//           </p>
//           <Link to="/dashboard/settings"
//         className="bg-yellow-50 px-3 py-1 flex items-center gap-1 rounded-md font-medium">
//         <button>Edit</button>
//           <RiEditBoxLine />
//         </Link>
//         </div>
//         <div className="flex md:flex-row flex-col gap-y-5 md:gap-y-0 max-w-[500px] justify-between">
//           <div className="flex flex-col gap-y-5">
//             <div>
//               <p className="mb-2 text-sm text-richblack-600">First Name</p>
//               <p className="text-sm font-medium text-richblack-800">
//                 {user?.firstName}
//               </p>
//             </div>
//             <div>
//               <p className="mb-2 text-sm text-richblack-600">Email</p>
//               <p className="text-sm font-medium text-richblack-800">
//                 {user?.email}
//               </p>
//             </div>
//             <div>
//               <p className="mb-2 text-sm text-richblack-600">Gender</p>
//               <p className="text-sm font-medium text-richblack-800">
//                 {user?.additionalDetails?.gender ?? "Add Gender"}
//               </p>
//             </div>
//           </div>
//           <div className="flex flex-col gap-y-5">
//             <div>
//               <p className="mb-2 text-sm text-richblack-600">Last Name</p>
//               <p className="text-sm font-medium text-richblack-800">
//                 {user?.lastName}
//               </p>
//             </div>
//             <div>
//               <p className="mb-2 text-sm text-richblack-600">Phone Number</p>
//               <p className="text-sm font-medium text-richblack-800">
//                 {user?.additionalDetails?.contactNumber ?? "Add Contact Number"}
//               </p>
//             </div>
//             <div>
//               <p className="mb-2 text-sm text-richblack-600">Date Of Birth</p>
//               <p className="text-sm font-medium text-richblack-800">
//                 {formattedDate(user?.additionalDetails?.dateOfBirth) ??
//                   "Add Date Of Birth"}
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }